import mixpanel from "mixpanel-browser";

import { alert } from "../components/common/Alert";
import { getTempScribenoteFlask } from "../utils";
import { API_HEADERS } from "./utils";

const SCRIBENOTE_FLASK = getTempScribenoteFlask();

export async function instantiateOrgPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-org-portal-session`, {
    method: "post",
    headers: API_HEADERS.headers(),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert(
        "error",
        `Failed to create organization portal session: ${error}`,
      );
    });
}

export async function instantiateCustomerPortal() {
  fetch(`${SCRIBENOTE_FLASK}/create-customer-portal-session`, {
    method: "post",
    headers: API_HEADERS.headers(),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      const redirectUrl = data.redirect;
      window.location.href = redirectUrl;
    })
    .catch((error) => {
      alert(
        "error",
        `Failed to create customer portal session: ${error}`,
      );
    });
}

export function handleSetup(returnUrl) {
  fetch(`${SCRIBENOTE_FLASK}/create-setup-session`, {
    method: "POST",
    headers: API_HEADERS.headers(),
    body: JSON.stringify({
      returnUrl: returnUrl,
    }),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        console.error(data.error);
        mixpanel.track("Billing Setup Failed", {
          error: data.error,
        });
        alert(
          "error",
          `Failed to create setup session: ${data.error}`,
        );
      } else {
        window.location = data.sessionUrl;
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

export function handleSubscribe({ priceId, route = "/account" }) {
  fetch(`${SCRIBENOTE_FLASK}/create-checkout-session`, {
    method: "POST",
    headers: API_HEADERS.headers(),
    body: JSON.stringify({
      priceId,
      returnUrl: `${window.location.origin}${route}`,
    }),
    credentials: "include",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        console.error(data.error);
        mixpanel.track("Upgrade Plan Failed", {
          error: data.error,
        });
        alert("error", data.error);
      } else {
        window.location = data.sessionUrl;
      }
    })
    .catch((err) => {
      console.error(err);
    });
}
